import { Box, TextField, styled } from "@mui/material"

export const StyledTextField = styled(TextField)(({ theme }) => ({
  // TODO: remove idle border, hover border & focus border
  "& .MuiInputBase-root": {},
  "& .MuiInputBase-focused": {},
  "& .MuiInputBase-input:focus": {},
  "& .MuiOutlinedInput-input": {
    borderWidth: "1px",
    borderColor: `${(theme.palette as any).foreground?.default} !important`,
    boxShadow: "1px 3px 3px 0px rgba(0, 0, 0, 0.10)"
  }
}))

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: (theme.palette as any).primary[300],
  borderRadius: "100px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "28px",
  minWidth: "28px",
  marginRight: theme.spacing(1)
}))
